"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var Label = function (_a) {
    var action = _a.action, children = _a.children, className = _a.className, direction = _a.direction, disabled = _a.disabled, error = _a.error, help = _a.help, optional = _a.optional, required = _a.required, props = __rest(_a, ["action", "children", "className", "direction", "disabled", "error", "help", "optional", "required"]);
    var getRequiredOptional = function () {
        var optionalUI = '(optional)';
        var requiredUI = '*';
        return required ? (react_1.default.createElement("span", { className: "Label__required" }, requiredUI)) : optional ? (react_1.default.createElement("span", { className: "Label__optional" }, optionalUI)) : undefined;
    };
    var getLabelHelp = function () {
        if (help === undefined || help === '')
            return false;
        if (typeof help === 'string') {
            return (react_1.default.createElement(__1.Tooltip, { text: help, direction: direction, onClick: preventControlFocus, portal: true },
                react_1.default.createElement(__1.Icon, { className: "Label__help", name: "help", size: "18" })));
        }
        return help;
    };
    /* If Label is in a <label>, it typically brings focus to another element. This function prevents this. */
    var preventControlFocus = function (e) {
        e.stopPropagation();
    };
    var LabelClasses = classnames_1.default('Label', className, {
        'Label--error': error,
        'Label--disabled': disabled,
    });
    return (react_1.default.createElement(__1.Stack, __assign({ className: LabelClasses }, props),
        react_1.default.createElement(__1.Stack.Item, { fill: true },
            children,
            getRequiredOptional(),
            getLabelHelp()),
        react_1.default.createElement("span", { className: "Label__action", onClick: preventControlFocus }, action)));
};
exports.Label = Label;
//# sourceMappingURL=Label.js.map